/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateManyPortfolioVinRequest
 */
export interface CreateManyPortfolioVinRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateManyPortfolioVinRequest
     */
    vins?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateManyPortfolioVinRequest
     */
    projectId?: string | null;
}

export function CreateManyPortfolioVinRequestFromJSON(json: any): CreateManyPortfolioVinRequest {
    return CreateManyPortfolioVinRequestFromJSONTyped(json, false);
}

export function CreateManyPortfolioVinRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateManyPortfolioVinRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vins': !exists(json, 'vins') ? undefined : json['vins'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
    };
}

export function CreateManyPortfolioVinRequestToJSON(value?: CreateManyPortfolioVinRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vins': value.vins,
        'projectId': value.projectId,
    };
}


